export const antThemeConfig = {
  hashed: false,
  cssVar: { key: 'app', prefix: 'oqio' },
  token: {
    fontFamily: 'var(--font-family-regular)',
    fontSizeHeading1: 32,
    fontSizeHeading2: 26,
    fontSizeHeading3: 20,
    fontSizeHeading4: 16,
    fontSizeHeading5: 12,
    // Must be a literal color here so AntD can generate hover/active shades (CSS vars break this)
    colorPrimary: '#627fff',
    colorInfo: '#627fff',
    colorSuccess: '#00ce82',
    colorWarning: '#ffdc00',
    colorError: '#ff5300',
    colorErrorOutline: '#ff5300',
    colorText: '#111111',
    colorTextPlaceholder: '#808080',
    colorTextDisabled: '#b3b3b3'
  },
  components: {
    Button: {
      colorPrimary: 'var(--primary-oqio-blue)',
      fontWeight: 500,
      colorPrimaryBorder: 'var(--primary-oqio-blue)',
      contentFontSize: 16,
      contentLineHeight: '20px',
      colorPrimaryHover: 'var(--primary-oqio-blue-hover)',
      paddingBlock: 10,
      paddingInline: 20,
      controlHeight: 40,
      fontSize: 16,
      primaryShadow: 'none',
      onlyIconSize: 20,
      marginXS: 6,
      colorError: 'var(--primary-oqio-red)',
      colorErrorHover: 'var(--primary-oqio-red-hover)',
      colorErrorBorderHover: 'var(--primary-oqio-red-hover)'
    },
    wave: { disabled: true },
    List: {
      fontFamily: 'var(--font-family-regular)'
    },
    Radio: {
      fontFamily: 'var(--font-family-regular)',
      fontSize: 16,
      radioSize: 20,
      dotSize: 10,
      colorPrimary: 'var(--primary-oqio-blue)'
    },
    Form: {
      labelFontSize: 12,
      labelHeight: 16,
      labelColor: 'var(--greyscale-shade)',
      verticalLabelPadding: '0 0 0 15px',
      colorError: 'var(--primary-oqio-red)',
      labelRequiredMarkColor: 'var(--greyscale-shade)',
      colorTextDescription: 'var(--greyscale-shade)'
    },
    Input: {
      activeBorderColor: 'var(--primary-oqio-blue)',
      activeShadow: 'var(--box-shadow-oqio-blue)',
      colorBgContainer: 'var(--greyscale-porcelain)',
      colorBorder: 'var(--greyscale-concrete)',
      colorError: 'var(--primary-oqio-red)',
      controlHeight: 40,
      borderRadius: 6,
      errorActiveShadow: 'var(--box-shadow-oqio-red)',
      fontSize: 16, // --font-size-regular
      hoverBorderColor: 'var(--primary-oqio-blue)',
      lineHeight: 1.25, // --font-line-height-regular (20px / 16px)
      paddingBlock: 9,
      paddingInline: 14
    },
    InputNumber: {
      activeBorderColor: 'var(--primary-oqio-blue)',
      activeShadow: 'var(--box-shadow-oqio-blue)',
      addonBg: 'var(--greyscale-porcelain)',
      colorBgContainer: 'var(--greyscale-porcelain)',
      colorBorder: 'var(--greyscale-concrete)',
      colorError: 'var(--primary-oqio-red)',
      controlHeight: 40,
      borderRadius: 6,
      errorActiveShadow: 'var(--box-shadow-oqio-red)',
      fontSize: 16, // --font-size-regular
      hoverBorderColor: 'var(--primary-oqio-blue)',
      lineHeight: 1.25, // --font-line-height-regular (20px / 16px)
      paddingBlock: 9,
      paddingInline: 14
    },
    DatePicker: {
      activeBorderColor: 'var(--primary-oqio-blue)',
      activeShadow: 'var(--box-shadow-oqio-blue)',
      controlHeight: 40,
      colorBgContainer: 'var(--greyscale-porcelain)',
      colorBorder: 'var(--greyscale-concrete)',
      colorTextPlaceholder: 'var(--greyscale-shade)',
      borderRadius: 6,
      errorActiveShadow: 'var(--box-shadow-oqio-red)',
      hoverBorderColor: 'var(--primary-oqio-blue)',
      paddingBlock: 9,
      paddingInline: 14
    },
    Select: {
      activeBorderColor: 'var(--primary-oqio-blue)',
      activeOutlineColor: 'var(--primary-oqio-blue)',
      colorBgContainer: 'var(--greyscale-porcelain)',
      colorBorder: 'var(--greyscale-concrete)',
      controlHeight: 40,
      lineHeight: 1.25, // --font-line-height-regular (20px / 16px)
      fontSize: 16, // --font-size-regular
      fontHeight: 20, // Math.round(16 * 1.25) — global fontHeight uses default 14px so must override
      paddingBlock: 9,
      paddingInline: 14,
      hoverBorderColor: 'var(--primary-oqio-blue)',
      showArrowPaddingInlineEnd: 18,
      borderRadius: 6,
      borderRadiusLG: 6,
      optionFontSize: 16,
      optionLineHeight: 1.25, // global lineHeight (~1.5714) gives 25px content; must override to get 20px
      optionHeight: 40, // minHeight for option item (20px text + 10px padding * 2)
      optionSelectedFontWeight: 500,
      optionPadding: '10px 14px',
      optionSelectedColor: 'var(--greyscale-blackish)',
      optionActiveBg: 'var(--greyscale-porcelain)',
      optionSelectedBg: 'var(--greyscale-white)',
      fontWeightStrong: 500
    },
    Table: {
      headerBg: 'var(--greyscale-white)',
      headerSortHoverBg: 'var(--greyscale-white)',
      headerSortActiveBg: 'var(--greyscale-white)',
      bodySortBg: 'var(--greyscale-white)',
      fontSize: 16,
      rowHoverBg: 'var(--greyscale-porcelain)',
      stickyScrollBarBg: 'rgba(136, 136, 136, 0.3) transparent'
    },
    Checkbox: {
      colorBgContainer: 'var(--greyscale-porcelain)',
      colorBorder: 'var(--greyscale-concrete)',
      colorPrimary: 'var(--primary-oqio-blue)',
      fontSize: 16,
      colorPrimaryHover: 'var(--primary-oqio-blue-hover)',
      controlInteractiveSize: 20,
      colorTextDisabled: 'var(--greyscale-concrete)'
    },
    Switch: {
      handleBg: 'var(--greyscale-white)',
      handleShadow: '0 0 4px 1px rgb(17 17 17 / 10%)',
      handleSize: 18,
      trackHeight: 20,
      trackMinWidth: 40,
      trackPadding: 1
    },
    Tabs: {
      itemColor: 'var(--greyscale-shade)',
      itemHoverColor: 'var(--greyscale-blackish)',
      itemSelectedColor: 'var(--greyscale-blackish)',
      inkBarColor: 'var(--greyscale-blackish)',
      horizontalItemPadding: '20px 10px 10px',
      fontSize: 16,
      lineHeight: '20px',
      horizontalItemGutter: 10
    },
    Drawer: {
      boxShadowDrawerUp: 'none',
      boxShadowDrawerDown: 'none',
      boxShadowDrawerLeft: 'none',
      boxShadowDrawerRight: 'none'
    },
    Menu: {
      itemColor: 'var(--greyscale-shade)',
      itemHoverBg: 'var(--secondary-whisper)',
      itemHoverColor: 'var(--greyscale-blackish)',
      itemSelectedBg: 'var(--greyscale-dark-white)',
      itemSelectedColor: 'var(--greyscale-blackish)',
      borderRadius: 8,
      borderRadiusLG: 8,
      fontSize: 16,
      itemSelectedFontWeight: 500
    },
    Notification: {
      borderRadiusLG: 6,
      boxShadow: '0 1px 20px 0 rgb(17 17 17 / 10%)',
      colorBgElevated: 'var(--greyscale-white)',
      colorIcon: 'var(--greyscale-blackish)',
      colorIconHover: 'var(--greyscale-blackish)',
      colorTextHeading: 'var(--greyscale-blackish)',
      fontSizeLG: 16,
      lineHeightLG: 1.25, // also sizes the icon slot to 20px
      marginSM: 30, // + icon size = text indent of 50
      marginXS: 20,
      paddingContentHorizontalLG: 0,
      paddingLG: 40,
      paddingMD: 0,
      width: 390
    },
    Steps: {
      dotCurrentSize: 14
    }
  }
};
